export default __webpack_public_path__ + "static/media/v.a7b167bc.png";